<template>
	<v-dialog
		v-model="showDialog"
		max-width="700"
		@click:outside="showDialog = false"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">部品調達依頼作成</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-toolbar-title style="color: white" @click="showDialog = false"
					><v-icon>mdi-close</v-icon></v-toolbar-title
				>
			</v-toolbar>
			<v-sheet elevation="0" class="pa-2">
				<div class="pa-2">
					<div class="font-weight-bold text-body-1">依頼調達する部品を選択</div>
					<v-radio-group v-model="componentRequirementType" row hide-details="">
						<v-radio @click="changeFormType" label="受注製品から選択" value="ordered"></v-radio>
						<v-radio
							@click="changeFormType"
							label="全ての部品から選択"
							value="all_components"
						></v-radio>
					</v-radio-group>
				</div>
				<!-- TODO ここ以降はコンポーネント化して、共通化すること -->
				<template v-if="componentRequirementType == 'ordered'">
					<v-form class="pa-2" ref="form1" v-model="valid">
						<div class="search-area">
							<v-text-field
								:rules="[rules.required]"
								:ref="`ordered_product_text_field`"
								v-model="orderedProduct"
								class="mt-4"
								:hint="orderedProductHint"
								:persistent-hint="!!selectedOrderedProduct"
								label="製品検索(必須)"
								outlined
								dense
								:class="{ 'custom-disabled-text-color': !!selectedOrderedProduct }"
								:readonly="!!selectedOrderedProduct"
								@keyup="setSearchOrderedProduct($event)"
							>
								<template v-if="selectedOrderedProduct" v-slot:append>
									<v-btn @click="removeCard()" icon small>
										<v-icon>mdi-close</v-icon>
									</v-btn>
								</template>
							</v-text-field>
							<OrderedProductSearchResult
								v-if="orderedProductResultFlag"
								:ordered_products="ordered_products"
								:options="options"
								@set="setOrderedProduct($event)"
							/>

							<v-row no-gutters>
								<v-col cols="12" sm="6">
									<v-row no-gutters class="flex-nowrap">
										<v-select
											:rules="[rules.required]"
											v-model="selectedOrderComponent"
											label="部品選択(必須)"
											:items="orderComponents"
											class="mt-2 mr-1"
											item-text="component.name"
											item-value="id"
											dense
											outlined
											return-object
											:disabled="orderComponents.length == 0"
											:hint="!!selectedOrderedProduct ? '' : '製品を先に選択してください'"
											:persistent-hint="!(!selectedOrderComponent.length && quantityFields.length)"
											no-data-text="データがありません"
										/>
									</v-row>
								</v-col>
							</v-row>

							<div v-if="selectedOrderComponent.component" class="quantity-field-area">
								<v-row no-gutters align="center">
									<v-col cols="12" sm="6">
										<v-row no-gutters>
											<v-col cols="12" sm="11">
												<p class="pb-4 ml-4">
													部品名：{{ selectedOrderComponent.component.name }}　　品番：{{
														selectedOrderComponent.component.part_number
													}}
												</p>
											</v-col>
										</v-row>
									</v-col>
								</v-row>
								<v-row no-gutters class="top-divider" align="center">
									<v-col cols="6">
										<v-text-field
											v-model="quantity"
											class="mt-2 append-outer"
											:rules="[rules.required]"
											label="数量(必須)"
											outlined
											dense
										>
										</v-text-field>
									</v-col>
									<v-col cols="6">
										<v-menu
											ref="menu"
											v-model="menu1"
											:close-on-content-click="false"
											:nudge-right="40"
											transition="scale-transition"
											offset-y
										>
											<template v-slot:activator="{ on }">
												<v-text-field
													v-model="expectedReceivingDate"
													label="希望納期(必須)"
													readonly
													outlined
													:rules="[rules.required]"
													dense
													v-on="on"
													class="mt-2 ml-2"
												>
												</v-text-field>
											</template>
											<v-date-picker
												v-model="expectedReceivingDate"
												no-title
												scrollable
												locale="ja"
												@input="menu1 = false"
											>
											</v-date-picker>
										</v-menu>
									</v-col>
									<v-col cols="6">
										<v-text-field
											v-model="subtitle"
											class="mt-2 append-outer"
											label="サブタイトル"
											outlined
											dense
										>
										</v-text-field>
									</v-col>
								</v-row>
								<v-row no-gutters>
									<v-col cols="12">
										<v-textarea
											v-model="message"
											class="mt-2"
											label="依頼理由(必須)"
											outlined
											:rules="[rules.required]"
										>
										</v-textarea>
									</v-col>
								</v-row>
							</div>
						</div>

						<v-btn dark color="secondary" class="mt-4" @click="$refs.uploadFile.click()">
							<v-icon class="mr-2">mdi-paperclip-plus</v-icon>
							添付ファイルを追加
							<input
								type="file"
								class="d-none"
								ref="uploadFile"
								@change="addFiles($event)"
								multiple
							/>
						</v-btn>

						<div class="file-area mt-2">
							<span v-if="allFiles < 1" class="filename">選択されていません</span>
							<template v-else>
								<v-chip
									class="ma-1 mt-2"
									close
									label
									outlined
									color="primary"
									@click:close="removeFile(i)"
									v-for="(file, i) in files"
									:key="file.name"
								>
									<v-icon class="mr-1">mdi-paperclip</v-icon>
									{{ file.name }}
								</v-chip>
							</template>
						</div>

						<v-divider class="my-2"></v-divider>
					</v-form>
				</template>
				<template v-if="componentRequirementType == 'all_components'">
					<v-form class="pa-2 mt-2" ref="form2" lazy-validation v-model="valid">
						<IncrementalSearchForm
							:url="'/erp/v1/incremental/components'"
							:label="'部品名と部品品番で検索'"
							:items="items"
							:returnObject="true"
							:value.sync="value"
							:no-data-text="'部品が見つかりません'"
							:clearable="true"
							:keywordKey="'component_name_and_part_number_cont'"
							:itemText="'component_name_and_part_number'"
						/>
						<div class="quantity-field-area" v-if="value">
							<v-row no-gutters align="center">
								<v-col cols="12" sm="6">
									<v-row no-gutters>
										<v-col cols="12" sm="11">
											<p v-if="value" class="pb-4 ml-4">
												部品名：{{ value.name }}　　品番：{{ value.part_number }}
											</p>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
							<v-row no-gutters class="top-divider" align="center">
								<v-col cols="6">
									<v-text-field
										v-model="quantity"
										class="mt-2 append-outer"
										label="数量(必須)"
										outlined
										dense
										:rules="[rules.required]"
									>
									</v-text-field>
								</v-col>
								<v-col cols="6">
									<v-menu
										ref="menu"
										v-model="menu1"
										:close-on-content-click="false"
										:nudge-right="40"
										transition="scale-transition"
										offset-y
									>
										<template v-slot:activator="{ on }">
											<v-text-field
												v-model="expectedReceivingDate"
												label="希望納期(必須)"
												readonly
												outlined
												dense
												v-on="on"
												:rules="[rules.required]"
												class="mt-2 ml-2"
											></v-text-field>
										</template>
										<v-date-picker
											v-model="expectedReceivingDate"
											no-title
											scrollable
											locale="ja"
											@input="menu1 = false"
										>
										</v-date-picker>
									</v-menu>
								</v-col>
								<v-col cols="6">
									<v-text-field
										v-model="subtitle"
										class="mt-2 append-outer"
										label="サブタイトル"
										outlined
										dense
									>
									</v-text-field>
								</v-col>
							</v-row>
							<v-row no-gutters>
								<v-col cols="12">
									<v-textarea
										v-model="message"
										class="mt-2"
										label="依頼理由(必須)"
										outlined
										:rules="[rules.required]"
									>
									</v-textarea>
								</v-col>
							</v-row>
						</div>
						<v-btn dark color="secondary" class="mt-4" @click="$refs.uploadFile.click()">
							<v-icon class="mr-2">mdi-paperclip-plus</v-icon>
							添付ファイルを追加
							<input
								type="file"
								class="d-none"
								ref="uploadFile"
								@change="addFiles($event)"
								multiple
							/>
						</v-btn>

						<div class="file-area mt-2">
							<span v-if="allFiles < 1" class="filename">選択されていません</span>
							<template v-else>
								<v-chip
									class="ma-1 mt-2"
									close
									label
									outlined
									color="primary"
									@click:close="removeFile(i)"
									v-for="(file, i) in files"
									:key="file.name"
								>
									<v-icon class="mr-1">mdi-paperclip</v-icon>
									{{ file.name }}
								</v-chip>
							</template>
						</div>
					</v-form>
				</template>
				<v-row class="ma-0 pa-0" justify="center">
					<v-btn
						v-if="componentRequirementType == 'ordered'"
						class="ma-1 white--text font-weight-bold"
						@click="openConfirmationDialog()"
						dense
						color="secondary"
						:disabled="!valid || !isButtonDisabled"
					>
						<v-icon class="mr-2">mdi-checkbox-marked-outline</v-icon>
						作成する</v-btn
					>
					<v-btn
						v-if="componentRequirementType == 'all_components'"
						:disabled="!componentSearchDialogDisabled"
						class="ma-1 white--text font-weight-bold"
						@click="openConfirmationDialog()"
						dense
						color="secondary"
					>
						<v-icon class="mr-2">mdi-checkbox-marked-outline</v-icon>
						作成する</v-btn
					>
				</v-row>
				<ConfirmationDialog
					:dialog.sync="confirmationDialog"
					:createRequirementFlag="createRequirementFlag"
					@createRequirement="createRequirement"
					:dialogTitle="dialogTitle"
					:dialogContent="dialogContent"
				/>
			</v-sheet>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import rules from "../../../helper/rules"
import moment from "moment"
import "moment/locale/ja"
import OrderedProductSearchResult from "./OrderedProductSearchResult.vue"
import ConfirmationDialog from "./ComponentProcurementConfirmationDialog.vue"
import IncrementalSearchForm from "../../shared/IncrementalSearchForm.vue"
import PaginationModule from "../../../modules/PaginationModule.vue"
export default {
	components: {
		OrderedProductSearchResult,
		IncrementalSearchForm,
		PaginationModule,
		ConfirmationDialog,
	},
	props: {
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},
		requirement_id: {
			type: null,
			required: false,
		},
	},
	data() {
		return {
			valid: false,
			rules: rules,
			authority_flag: false,
			requirement: {},
			componentRequirementType: "",
			selectedOrderedProduct: null,
			selectedMatterProduct: null,
			selectedComponent: null,
			selectedOrderComponentCards: [],
			ordered_products: [],
			orderedProductResultFlag: false,
			selectComponentFlag: false,
			confirmationDialog: false,
			orderedProduct: null,
			orderedProductErrorFlag: false,
			ordered_product_keyword: null,
			searchOrderedProductTimer: null,
			orderComponents: [],
			selectedOrderComponent: [],
			quantityFields: [],
			quantity: "",
			files: [],
			removefiles: [],
			orderedTab: null,
			yetTab: null,
			options: {
				isEmpty: null,
			},
			menu1: false,
			expectedReceivingDate: null,
			confirmationDialog: false,
			label: "製品検索",
			searchWord: null,
			searchNumber: null,
			selectedComponents: [],
			openDataTable: false,
			headers: [
				// { text: "選択", value: "", width: "50px", divider: true },
				{ text: "部品品番", value: "part_number", width: "200px", divider: true },
				{ text: "部品名", value: "name", width: "200px", divider: true },
			],
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			items: [],
			value: null,
			dialogTitle: "",
			dialogContent: "",
			message: "",
			subtitle: "",
			createRequirementFlag: false,
		}
	},

	methods: {
		closeDialog() {
			this.selectedOrderedProduct = ""
			this.orderedProduct = ""
			this.selectedOrderComponent = ""
			this.quantity = ""
			this.subtitle = ""
			this.expectedReceivingDate = ""
			this.message = ""
			this.files = []
			this.componentRequirementType = ""
			this.showDialog = false
		},
		createRequirement() {
			const headers = authenticate.setHeader()
			axios
				.post(`/erp/v1/component_procurement_requirements/component_procurement_requirements`, {
					headers,
				})
				.then((res) => {})
				.catch((err) => {
					console.log(err)
					errorHandling.errorResponse(err)
				})
		},
		changeFormType() {
			this.valid = false
			this.orderedProduct = ""
			this.selectedOrderedProduct = null
			this.selectedOrderComponent = ""
			this.quantity = ""
			this.expectedReceivingDate = ""
			this.subtitle = ""
			this.message = ""
			this.files = []
			this.menu1 = false
			this.value = ""
		},

		setSearchOrderedProduct(e) {
			if (e.key == "ArrowDown" || e.key == "ArrowUp") return // 上下移動はセレクトの選択に利用するので、利用するので、アクションを起こさない
			this.ordered_products = []
			this.ordered_product_keyword = e.target.value
			clearTimeout(this.searchOrderedProductTimer) // 連続でタイプした時用に前のタイマーをキャンセル
			if (!this.ordered_product_keyword.length) return // 0文字の場合はreturn
			this.searchOrderedProductTimer = setTimeout(this.searchOrderComponent, 500) // 連続でタイプするとアクセスが走りすぎるため.5秒後に発火
		},
		setOrderedProduct(ordered_product) {
			this.orderComponents = ordered_product.order_components // 部品選択のitemsをセット
			this.ordered_products = [] // 製品検索結果をリセット
			this.selectedOrderComponent = [] //選択部品をリセット
			this.ordered_product_keyword = "" // 製品検索キーワードをリセット
			// カードから部品を削除
			this.quantityFields = []
			this.selectedOrderedProduct = ordered_product
			this.orderedProduct = `製造番号: ${ordered_product.product_number} 製品名: ${ordered_product.product.name}`
			this.setOrderedProductCard()
			this.orderedProductResultFlag = false
		},
		setOrderedProductCard() {
			this.orderedProductCardFlag = true
			this.orderedProductCardTexts = [this.selectedOrderedProduct]
		},
		searchOrderComponent() {
			const params = {
				q: {
					product_number_cont: this.ordered_product_keyword,
				},
			}
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/search_order_components", {
					headers,
					params,
				})
				.then((res) => {
					this.ordered_products = res.data.ordered_products
					this.searchOrderedProductTimer = null
					this.orderedProductErrorFlag = false
					this.orderedProductResultFlag = true
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},

		addFiles(e) {
			const files = e.target.files
			Object.entries(files).forEach((file) => {
				this.files.push(file[1])
			})
		},
		removeFile(index) {
			const removeFile = this.files[index]
			this.files.splice(index, 1)
			this.removefiles.push(removeFile)
		},
		removeCard() {
			this.quantityFields = [] // 個数フィールドを初期化し、１つ追加
			this.quantityFieldFlag = false // 個数フィールド非表示
			this.selectedOrderComponent = [] // 選択部品を初期化
			this.orderComponents = [] // 部品検索結果を初期化
			this.orderedProductCardTexts = [] // 製品カードテキストを初期化
			this.orderedProductCardFlag = false //カード非表示
			this.selectedOrderedProduct = null // 選択製品を初期化
			this.orderedProduct = null // 製品検索結果を初期化
		},

		openConfirmationDialog() {
			this.dialogTitle = "部品調達依頼作成"
			this.dialogContent = "部品調達依頼を作成しますか？"
			this.createRequirementFlag = true
			this.confirmationDialog = true
		},
		searchComponents(page) {
			const headers = authenticate.setHeader()
			const params = {
				name_cont: this.searchWord,
				part_number_cont: this.searchNumber,
			}
			axios
				.get(`/erp/v1/order_data/search_components`, {
					headers,
					params: { q: params, page },
				})
				.then((res) => {
					this.components = res.data.components
					this.openDataTable = true
					this.pagination = res.data.pagination
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		getPage(page) {
			this.searchComponents(page)
		},
		createRequirement() {
			const headers = authenticate.setHeader()
			let formData = new FormData()
			if (this.files.length) {
				this.files.forEach((file) => {
					formData.append(
						"files" + "[]",
						new Blob([file], {
							type: file.type,
						}),
						file.name
					)
				})
			}
			if (this.selectedOrderedProduct && this.selectedOrderComponent) {
				formData.set("requirement[ordered_product_id]", this.selectedOrderedProduct.id)
				formData.set("requirement[order_component_id]", this.selectedOrderComponent.id)
				formData.set("requirement[component_id]", this.selectedOrderComponent.component.id)
				formData.set("requirement[quantity]", this.quantity)
				formData.set("requirement[subtitle]", this.subtitle)
				formData.set("requirement[expected_receiving_date]", this.expectedReceivingDate)
				formData.set("requirement[message]", this.message)
			} else {
				formData.set("requirement[component_id]", this.value.id)
				formData.set("requirement[quantity]", this.quantity)
				formData.set("requirement[subtitle]", this.subtitle)
				formData.set("requirement[expected_receiving_date]", this.expectedReceivingDate)
				formData.set("requirement[message]", this.message)
			}
			axios
				.post(
					`/erp/v1/component_procurement_requirements/component_procurement_requirements`,
					formData,
					{
						headers,
					}
				)
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "部品調達依頼を作成しました",
					})
					this.closeDialog()
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
		isButtonDisabled() {
			return this.selectedOrderedProduct && this.selectedOrderComponent.component
		},
		componentSearchDialogDisabled() {
			return this.value && this.quantity && this.expectedReceivingDate && this.message
		},

		orderedProductHint() {
			if (this.ordered_products.length) {
				return "製品を選択してください"
			} else if (this.searchOrderedProductTimer) {
				return "製品を取得しています"
			} else if (!this.ordered_products.length && this.ordered_product_keyword) {
				return "該当する製品が存在していません"
			} else if (this.orderedProductErrorFlag && !this.ordered_product_keyword) {
				return "選択肢から製品を選択してください"
			} else if (this.selectedOrderedProduct) {
				return "選択された製品のリセットは右の×ボタンで行えます"
			} else {
				return "製造番号を入力してください"
			}
		},
		allFiles() {
			if (this.files) {
				return this.files.length
			}
		},
	},
}
</script>
